import React, { useEffect } from 'react';
import { FaHome, FaUsers, FaFileContract } from 'react-icons/fa';
import PracticeAreaLayout from './PracticeAreaLayout';

const RealEstatePage: React.FC = () => {
  useEffect(() => {
    document.title = 'Real Estate Law | Janssen Law Professional Corporation';
  }, []);

  return (
    <PracticeAreaLayout
      title="Real Estate Law"
      subtitle="Trusted legal guidance for residential and commercial real estate transactions across Ontario."
      heroImage="https://janssen-law.s3.us-east-2.amazonaws.com/real-estate-law.png"
      slug="real-estate"
      overview={
        <>
          <p>
            Our real estate practice covers the full spectrum of property transactions,
            from residential purchases and sales to complex commercial deals. We guide
            clients through every step of the process, ensuring that your interests are
            protected and transactions proceed smoothly.
          </p>
          <p>
            With multiple lawyers experienced in real estate law, including Janith and
            Linh, we have the capacity to handle a high volume of transactions while
            maintaining the personalized attention our clients expect.
          </p>
          <p>
            Whether you are a first-time home buyer, a seasoned investor, or a
            commercial developer, we provide clear, practical advice to help you
            navigate Ontario's real estate landscape with confidence.
          </p>
        </>
      }
      services={[
        'Residential Purchases & Sales',
        'Commercial Real Estate Transactions',
        'Title Searches & Insurance',
        'Mortgage Documentation & Refinancing',
        'Land Transfer & Registration',
        'Development Project Review',
        'Lease Negotiations & Reviews',
        'Condominium Transactions',
        'Property Disputes',
        'Power of Sale Proceedings',
        'Zoning & Land Use Matters',
        'Real Estate Investment Structures',
      ]}
      whyUsTitle="Why Choose Janssen Law for Real Estate?"
      whyUsDescription="A dedicated real estate team with deep experience in Ontario property law and a commitment to smooth, timely closings."
      whyUsFeatures={[
        {
          icon: <FaHome />,
          title: 'Dedicated Team',
          description:
            'Multiple lawyers focused on real estate means faster turnaround and specialized expertise for your transaction.',
        },
        {
          icon: <FaUsers />,
          title: 'Full-Service Approach',
          description:
            'We handle related corporate, financing, and estate planning matters alongside your property transaction.',
        },
        {
          icon: <FaFileContract />,
          title: 'Thorough Due Diligence',
          description:
            'Comprehensive title searches, document review, and closing procedures to protect your investment.',
        },
      ]}
    />
  );
};

export default RealEstatePage;
